<template>
  <div v-if="hasVideoUrl">
    <div>
      <p><strong>{{ $t('posts.networks.videoTitre') }}</strong></p>
    </div>
    <el-form-item :error="inputError">
      <el-row :gutter="24">
        <el-col :span="20">
          <el-input
            v-model="postVideoFileUrlCustom"
            type="url"
            @change="savePostVideoUrl"
            :disabled="(data.statusPost === 'isCurrentlyPublished') || data.isCurrentlyPublished || (data.statusPost === 'published')"
            clearable
            placeholder="URL de votre vidéo"
          ></el-input>
        </el-col>
        <el-col :span="4" class="text-center">
          <el-tooltip :content="'Remettre l\'URL initiale'" placement="top">
            <el-button
              @click="resetToParentUrl"
              :disabled="!parentVideoUrl || (data.statusPost === 'isCurrentlyPublished') || data.isCurrentlyPublished || (data.statusPost === 'published')"
              size="medium"
              style="margin-bottom: 15px;"
            >
              <i class="el-icon-refresh-left" style="font-size: 18px;"></i>
            </el-button>
          </el-tooltip>
        </el-col>
      </el-row>
    </el-form-item>
    <div v-if="possedeClapVideo && this.data && this.data.post && this.data.post.url_clap">
      <el-button @click="copyClap" type="primary">{{ $t('posts.networks.videoButtonClap') }}</el-button>
      <br />
    </div>
  </div>
</template>

<script>

import { $t } from '@/i18n'

export default {
  name: 'PostVideoFileUrlCustom',
  props: {
    data: Object,
    parentVideoUrl: String
  },
  data () {
    return {
      hasVideoUrl: false,
      postVideoFileUrlCustom: '',
      inputError: ''
    }
  },
  computed: {
    sitimmoUser () {
      return this.$store.state.app.sitimmoUser
    },
    user () {
      return this.$store.state.app.user
    },
    possedeClapVideo () {
      return this.user.possedeClap
    }
  },
  watch: {
    parentVideoUrl: {
      handler (newUrl) {
        // Si l'URL parent change et qu'on n'a pas de personnalisation pour ce réseau
        const diffuseurClef = this.data.networkName.toLowerCase()
        const hasCustomization = this.data && this.data.post && this.data.post.donnees &&
                                this.data.post.donnees.post_video_file_url_custom &&
                                this.data.post.donnees.post_video_file_url_custom.valeur &&
                                this.data.post.donnees.post_video_file_url_custom.valeur.hasOwnProperty(diffuseurClef)

        // Seulement mettre à jour si pas de personnalisation explicite
        if (!hasCustomization && newUrl !== this.postVideoFileUrlCustom) {
          this.postVideoFileUrlCustom = newUrl || ''
        }
      },
      immediate: true
    }
  },
  methods: {
    savePostVideoUrl () {
      this.inputError = ''
      const diffuseurClef = this.data.networkName.toLowerCase()

      // Valider l'URL si elle n'est pas vide
      if (this.postVideoFileUrlCustom && this.postVideoFileUrlCustom.trim() !== '') {
        const urlVideo = this.urlIsValid(this.postVideoFileUrlCustom)
        if (!urlVideo) {
          this.inputError = $t('posts.networks.videoUrlError')
          this.$emit('updateValue', 'invalidUrl', this.inputError)
          this.$message({ message: $t('posts.networks.videoUrlError'), type: 'error', duration: 4000 })
          return false
        }
      }

      this.$emit('updateValue', 'invalidUrl', 'delete')

      // S'assurer que la structure existe
      if (!this.data.post.donnees) {
        this.$set(this.data.post, 'donnees', {})
      }
      if (!this.data.post.donnees.post_video_file_url_custom) {
        this.$set(this.data.post.donnees, 'post_video_file_url_custom', {
          famille: 'Usage interne',
          libelle: 'URL fichiers video',
          flux: this.data.emission.codeName,
          valeur: {},
          unite: '',
          private: true,
          internal: true
        })
      }
      if (!this.data.post.donnees.post_video_file_url_custom.valeur) {
        this.$set(this.data.post.donnees.post_video_file_url_custom, 'valeur', {})
      }

      // Sauvegarder la valeur (même si elle est vide) pour marquer la personnalisation explicite
      const urlValue = this.postVideoFileUrlCustom ? this.postVideoFileUrlCustom.trim() : ''
      this.$set(this.data.post.donnees.post_video_file_url_custom.valeur, diffuseurClef, urlValue)

      // Émettre le changement vers le parent
      this.$emit('video-url-changed', {
        network: this.data.networkName,
        url: urlValue
      })
    },
    urlIsValid (urlString) {
      let isValid = false
      try {
        const urlVideo = new URL(urlString)
        isValid = (
          ((urlVideo.protocol === 'http:') || (urlVideo.protocol === 'https:')) &&
          (urlVideo.hostname.indexOf('youtube') === -1) &&
          (urlVideo.hostname.indexOf('dailymotion') === -1)
        )
      } catch (_) {
      }
      return isValid
    },
    copyClap () {
      this.postVideoFileUrlCustom = this.data.post.url_clap
      this.savePostVideoUrl()
    },
    resetToParentUrl () {
      this.postVideoFileUrlCustom = this.parentVideoUrl || ''
      // Supprimer complètement la personnalisation pour ce réseau
      if (this.data.post.donnees &&
          this.data.post.donnees.post_video_file_url_custom &&
          this.data.post.donnees.post_video_file_url_custom.valeur) {
        const diffuseurClef = this.data.networkName.toLowerCase()
        this.$delete(this.data.post.donnees.post_video_file_url_custom.valeur, diffuseurClef)

        // Si plus aucune URL, supprimer complètement la structure
        if (Object.keys(this.data.post.donnees.post_video_file_url_custom.valeur).length === 0) {
          this.$delete(this.data.post.donnees, 'post_video_file_url_custom')
        }
      }

      // Émettre le changement vers le parent (sera l'URL initiale ou vide)
      this.$emit('video-url-changed', {
        network: this.data.networkName,
        url: this.postVideoFileUrlCustom
      })

      this.$message({
        type: 'success',
        message: `URL ${this.data.networkName} remise à l'état initial`
      })
    }
  },
  beforeMount () {
    if (this.sitimmoUser.optionVideo) {
      this.hasVideoUrl = true
    }
  },
  mounted () {
    const diffuseurClef = this.data.networkName.toLowerCase()
    if (diffuseurClef) {
      if (this.data.post.donnees &&
          this.data.post.donnees.post_video_file_url_custom &&
          this.data.post.donnees.post_video_file_url_custom.valeur &&
          this.data.post.donnees.post_video_file_url_custom.valeur.hasOwnProperty(diffuseurClef)) {
        // Il y a une personnalisation explicite (même si elle est vide)
        this.postVideoFileUrlCustom = this.data.post.donnees.post_video_file_url_custom.valeur[diffuseurClef]
      } else if (this.parentVideoUrl) {
        // Si pas de personnalisation, utiliser l'URL parent
        this.postVideoFileUrlCustom = this.parentVideoUrl
      }
    }
  }
}
</script>

<style lang="scss">
.text-center {
  text-align: center;
}
</style>
